import { render, staticRenderFns } from "./OSelect.vue?vue&type=template&id=b91a6238&scoped=true&"
import script from "./OSelect.vue?vue&type=script&lang=js&"
export * from "./OSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91a6238",
  null
  
)

export default component.exports